// Pure classification of a POST /auth/send attempt's outcome.
//
// /auth/send DISPATCHES AN EMAIL, so it is never auto-retried (a silent
// retry sends a second magic link). The client also cannot tell, from a
// 5xx or a thrown fetch, whether the email actually went out — the worker
// returns 500 both when signInWithOtp failed (no email) AND, transiently,
// after it succeeded but the response was lost. So:
//   - ok                      -> sent          ("Check your inbox")
//   - definitive 4xx (400/403)-> error         (bad/Unauthorized email; show reason)
//   - everything else / threw -> indeterminate (can't confirm — try again)
// We must neither claim success (lies; user waits for an email that may
// never come) nor cry hard failure (the link may already be on its way).

export type SendOutcome = 'sent' | 'error' | 'indeterminate';

export function classifySendOutcome(input: {
  ok: boolean;
  /** HTTP status, or undefined when fetch threw before a response. */
  status?: number;
}): SendOutcome {
  if (input.ok) return 'sent';
  // Actionable client errors the worker emits: 400 (bad email) / 403
  // (email not authorized). These carry a useful server message.
  if (input.status === 400 || input.status === 403) return 'error';
  // 5xx, 429, or a thrown network error (status undefined): unconfirmable.
  return 'indeterminate';
}
